import { Component, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AdminDirectSystemLocation } from 'src/app/constants/admin-direct-system';
import { AgentLocationType } from 'src/app/constants/agent';
import { USStates } from 'src/app/constants/us-states';


@Component({
    selector: 'mwp-agent-location',
    templateUrl: './agent-location.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AgentLocation implements OnInit {
    @Input() public form: FormGroup
    @Input() public nameForRadioControl: string
    @Output() public displayWorkSiteInfo: boolean;

    public agentLocationEnum = AgentLocationType;
    public usStates = USStates;
    private locationName: string = 'location';

    constructor(
        private formBuilder: FormBuilder,
    ) { }

    ngOnInit(): void {
    }

    get locationFormGroup(): FormGroup {
        return this.form.get(this.locationName) as FormGroup;
    }

    public radioChange(eventValue: string) {
        if (eventValue == AdminDirectSystemLocation.Laptop) {
            const l_LocationForm = this.formBuilder.group({
                agentCity: [null, Validators.required],
                agentState: [null, Validators.required],
            });
            this.form.addControl(this.locationName, l_LocationForm);
        } else {
            this.form.removeControl(this.locationName);
        }
        this.displayWorkSiteInfo = eventValue == AdminDirectSystemLocation.Laptop;
    }
}